import * as React from 'react'

const FacebookLogoCircle: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width={35} height={35} viewBox="0 0 35 35" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#a)">
      <path
        d="M34.125 17.5c0-9.387-7.613-17-17-17s-17 7.613-17 17 7.613 17 17 17c.1 0 .2-.002.299-.004V21.262h-3.652v-4.256h3.652v-3.132c0-3.633 2.217-5.61 5.458-5.61 1.552 0 2.885.116 3.274.167v3.797h-2.234c-1.763 0-2.105.838-2.105 2.067v2.71h4.216l-.55 4.257h-3.666v12.581c7.106-2.037 12.308-8.583 12.308-16.343Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="transparent" transform="translate(.125 .5)" d="M0 0h34v34H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default FacebookLogoCircle
